import { List, Map } from 'immutable';
import { connect } from '../../react-redux';
import { closeModal } from '../../../common/actions/modal';
import { screenreaderNotification } from '../../../common/actions/alerts';
import { clearAltText, clearFiles, receiveFile, setAltText, uploadStatus as setUploadStatus } from '../../../common/actions/upload';
import { IMPORT_MODAL, FILE_UPLOAD_SELECT, FILE_UPLOAD_URL_CALL, FILE_UPLOAD_CALL } from '@instructure/quiz-common';
import { ImportModal as ImportModalPresenter } from './presenter';
var callsToCheck = [FILE_UPLOAD_URL_CALL, FILE_UPLOAD_CALL];
export function callProgress(callsToCheck) {
  var calls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Map();
  var successCount = calls.filter(function (value, key) {
    return callsToCheck.includes(key) && value.get('requestStatus') === 'success';
  }).size;
  return successCount / callsToCheck.length;
}
export function progressValue(progressNumber) {
  var callsMade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Map();
  var callsToCheck = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var callProgressWhenCompleted = 1;
  // We are using 50 because 50 == (100 / 2.0) and import and API calls each contribute 1/2 of the overall progress
  return progressNumber ?
  // If importing, then the calls are completed and we skip the calculation
  (callProgressWhenCompleted + progressNumber) * 50 :
  // If no progressNumber, then the callProgress counts is working on the first 50%
  callProgress(callsToCheck, callsMade) * 50;
}
export var generateImportModalId = function generateImportModalId(id) {
  return "".concat(id, "_").concat(IMPORT_MODAL);
};

// Every component ought to pass in the importModalId to help keep track of which importModal is supposed to be open
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    altText: state.getIn(['upload', 'altText'], ''),
    modalOpen: state.getIn(['modal', 'isOpen']) === generateImportModalId(props.importModalId),
    files: state.getIn(['upload', 'files'], List()),
    uploadStatus: state.getIn(['upload', 'status'], FILE_UPLOAD_SELECT),
    progressValue: callProgress(callsToCheck, state.get('calls')) * 100
  };
};
var mapDispatchToProps = {
  clearAltText: clearAltText,
  clearFiles: clearFiles,
  closeModal: closeModal,
  receiveFile: receiveFile,
  setAltText: setAltText,
  setUploadStatus: setUploadStatus,
  screenreaderNotification: screenreaderNotification
};
var mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};
export var ImportModal = connect(mapStateToProps, mapDispatchToProps, mergeProps)(ImportModalPresenter);
export default ImportModal;